import { toast } from "react-toastify";

import functions from "./functions";

const generateContent = (paramsObject: any) => {
    try {
        const { props, html } = paramsObject;
        const { block } = props;
        let content = html ? block.data.html : block.content;
        if (!content) {
            return null;
        }
        if (typeof content == 'object') {
            if (content.custom) {
                try {
                    content = eval(content.value);
                } catch (error) {
                    content = null;
                }
            } else {
                const fieldName = html ? block?.data?.html?.fieldName : block?.content?.fieldName;
                content = props?.singleData?.[fieldName];
            }
        }
        return content;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const generateCss = (paramsObject: any) => {
    try {
        const { props, classes } = paramsObject;
        const { block } = props;
        let css = classes || block?.css;
        if (!css) {
            return null;
        }
        if (typeof css == 'object') {
            try {
                css = eval(css.value);
            } catch (error) {
                css = null;
            }
        }
        if (props.builder || props.builderPreview || props.templatePreview || props?.componentsPreview || props.nextJs) {
            css = css.replace(
                /secondary_color|bg_color|textColor|primary_color|primary_color_light|primary_color_dark|primary_font_size|secondary_font_size|font_size/g,
                (match: any) => `[${props.theme?.[match]}]`
            );
            if (paramsObject.elementWithChildren) {
                if (css.includes('grid')) {
                    css += ' !block';
                }
            }
            if (paramsObject.sortableContainer) {
                css += ' !w-full !p-0 !m-0 !border-0 !static !shadow-none !transform-none !animate-none !bg-none !bg-transparent !h-full !max-w-none !min-w-0';
            }
        }
        return css;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const generateSrc = (paramsObject: any) => {
    try {
        const { props, key } = paramsObject;
        const { block } = props;
        if (!["img", "video"].includes(block.type) || !block?.data?.[key]) {
            return null;
        }
        if (typeof block.data[key] != 'object') {
            if (/^https?:\/\//.test(block?.data?.[key])) {
                return block.data[key];
            } else {
                return `${process.env.REACT_APP_CDN_URL}/${block.data[key]}`;
            }
        }
        else {
            if (block.data[key].custom) {
                const value = eval(block.data[key].value);
                if ((/^https?:\/\//.test(value))) {
                    return value;
                } else {
                    return `${process.env.REACT_APP_CDN_URL}/${value}`;
                }
            } else if (props.singleData && props.singleData[block.data[key].fieldName]) {
                if ((/^https?:\/\//.test(props.singleData[block.data[key].fieldName]))) {
                    return props.singleData[block.data[key].fieldName];
                } else {
                    return `${process.env.REACT_APP_CDN_URL}/${props.singleData[block.data[key].fieldName]}`;
                }
            } else {
                return null;
            }
        }
    } catch (error) {
        console.log(error);
        return null;

    }
};

const generateEvent = async (paramsObject: any) => {
    try {
        const { props, event } = paramsObject;
        const { block } = props;
        for (let i = 0; i < block?.events?.[event]?.length; i++) {
            if (!block.events[event][i]?.applyInBuilder) {
                let task = block?.events[event][i]?.task;
                if (task == 'custom') {
                    await eval(block?.events[event][i]?.parameters?.function);
                }
                else {
                    if (task in functions) {
                        await (functions as any)[block.events[event][i].task]({
                            ...paramsObject,
                            data: block.events[event][i].parameters
                        });
                    }
                }
            }
        }
    } catch (error) {
        console.log(error);
        if ((error as any).response) {
            toast.error((error as any).response.data.message);
        } else {
            toast.error("Something went wrong!");
        }
    }
};

const generateLink = (paramsObject: any) => {
    try {
        const { props, link } = paramsObject;
        if (props.componentsPreview) {
            return null;
        }
        let linkValue;
        if (link) {
            if (typeof link === 'object') {
                linkValue = eval(link.value);
            } else {
                linkValue = `${link === '/' ? (props.templatePreview || props.builderPreview) ? "" : '/' : link}`;
            }
        } else {
            return null;
        }
        if (/^(https?:\/\/[^\s/$.?#].[^\s]*|mailto:[^\s]+|tel:[^\s]+)$/i.test(linkValue)) {
            return linkValue;
        } else {
            let prefix = "";
            if (props.templatePreview) {
                prefix = `/${props.params.platform}/${props.params.templateVersionId}`;
            } else if (props.builderPreview) {
                prefix = `/preview/${props.params.projectId}/${props.params.platform}`;
            }
            return `${prefix}${linkValue}`;
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};

const generateValue = (paramsObject: any) => {
    try {
        const { props } = paramsObject;
        const { block } = props;
        if (block?.data?.value) {
            if (typeof block.data.value === 'object') {
                if (block.data.value?.custom) {
                    const data = eval(block.data.value.value);
                    return data;
                } else {
                    return props?.singleData?.[block.data.value?.fieldName];
                }
            } else {
                if (block.data?.type && (block.data.type === 'checkbox' || block.data.type === 'radio')) {
                    return block?.data?.value
                } else if (block?.data?.type !== 'file') {
                    return props.formik?.values?.[block?.data?.name];
                } else {
                    return null;
                }
            }
        } else {
            if (block?.type == 'textarea' || (block?.data?.type && block?.data?.type !== 'file')) {
                return props.formik?.values?.[block?.data?.name];
            } else {
                return null;
            }
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};

const generateStyle = (paramsObject: any) => {
    try {
        const { props } = paramsObject;
        const { block } = props;
        let styleObj: any = {
            fontFamily: block?.style?.fontFamily
        };
        if (block?.style?.backgroundImage && block?.style?.backgroundImage !== 'none') {
            if ((/^https?:\/\//.test(block?.style?.backgroundImage))) {
                styleObj.backgroundImage = `url(${block?.style?.backgroundImage})`;
            } else {
                styleObj.backgroundImage = `url(${process.env.REACT_APP_CDN_URL}/${block?.style?.backgroundImage})`;
            }
        }
        return styleObj;
    } catch (error) {
        console.error("error", error);
        return null;
    }
}

const checked = (paramsObject: any) => {
    try {
        const { props } = paramsObject;
        const { block } = props;
        if (block.data?.type !== 'checkbox' || block.data?.type !== 'radio' || !block?.data?.value) {
            return null;
        }
        let value;
        if (typeof block.data?.value === 'object') {
            if (block.data?.value?.custom) {
                value = eval(block?.data?.value?.value);
            } else {
                value = props?.singleData?.[block?.data?.value?.fieldName]?.toString();
            }
        } else {
            value = block?.data?.value;
        }
        if (block.data?.type === 'checkbox') {
            return props?.formik?.values?.[block?.data?.name]?.includes(value);
        } else if (block.data?.type === 'radio') {
            return props?.formik?.values?.[block?.data?.name] === value;
        }

    } catch (error) {
        console.log(error);
        return null;
    }
};

export { generateContent, generateCss, generateSrc, generateEvent, generateLink, generateValue, generateStyle, checked };